"use client";

import { Search } from "lucide-react";

import { KeyCombo } from "@/components/ui/kbd";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  NAV_ARRIVE,
  NAV_CORAL_MARK,
  NAV_FIELD,
  NAV_INK_FOCUS_RING,
  arriveStep,
} from "@/components/nav/nav-styles";
import { useApplePlatform } from "@/hooks/useApplePlatform";
import { searchKeys } from "@/lib/keyboard";
import { cn } from "@/lib/utils";

const FIELD_TRIGGER = cn(NAV_FIELD, NAV_INK_FOCUS_RING, NAV_ARRIVE);

/**
 * The white field in the top bar that opens search: the icon, what search
 * covers and the keys that open it. The tooltip names the keys in words.
 */
export default function NavSearchTrigger({ buttonRef, onClick }) {
  const apple = useApplePlatform();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          ref={buttonRef}
          type="button"
          onClick={onClick}
          aria-label="Search"
          className={FIELD_TRIGGER}
          style={arriveStep(0)}
        >
          <Search className={cn("h-4 w-4 shrink-0", NAV_CORAL_MARK)} />
          <span className="truncate">Search pages, people, content…</span>
          <KeyCombo keys={searchKeys(apple)} className="ml-auto" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        {apple
          ? "Hold Command and press K to open search."
          : "Hold Ctrl and press K to open search."}
      </TooltipContent>
    </Tooltip>
  );
}
